import React from 'react';
import RepProfileSkills from '$pages/$rep-profile/RepProfileSkills';
import CoachingPageContainer from 'components/coaching/CoachingPageContainer';
import {getQueryParam} from 'utils/getQueryParam';

export default class RepCoachingPlans extends React.Component {
  render() {
    const {RepProfilePageStore, SkillStore, UserStore, location} = this.props;
    const {didCoachingPlansFetchFail, areCoachingPlansFetching, selectedScoredByType} =
      RepProfilePageStore;

    const repBeingViewed = UserStore.users.get(this.props.repId);

    const didSkillsUserTrendFetchFail = SkillStore.wasErrorFetchingTeamTrends;

    const hasPlanId = getQueryParam(location, 'planId');

    return (
      <div className="tab-content rep-coaching-plans">
        {!hasPlanId &&
          (didSkillsUserTrendFetchFail || didCoachingPlansFetchFail ? (
            <p>There was a problem communicating with the server.</p>
          ) : (
            <RepProfileSkills
              {...this.props}
              rep={repBeingViewed}
              onSelectScoredByType={this.props.onSelectScoredByType}
              selectedScoredByType={selectedScoredByType}
              SkillStore={SkillStore}
              areCoachingPlansLoading={areCoachingPlansFetching}
              coachingPlans={RepProfilePageStore.coachingPlans}
              sessionUser={this.props.AuthStore.user}
            />
          ))}
        {hasPlanId && <CoachingPageContainer {...this.props} />}
      </div>
    );
  }
}
